import {
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';
import {
  welcomeOfferSlice,
  type WelcomeOfferState,
} from './slice';

type RootState = {
  [welcomeOfferSlice.name]: WelcomeOfferState;
};

export const selectWelcomeOfferTimerId = (state: RootState): Maybe<NodeJS.Timeout> => state[welcomeOfferSlice.name].timerId;

export const selectWelcomeOfferModalOpen = (state: RootState): boolean => state[welcomeOfferSlice.name].modalOpen;

export const useWelcomeOfferSelector: TypedUseSelectorHook<RootState> = useSelector;